import { DeleteRequest, GetListRequest, GetListResponse } from "./api.model";

export type PriceCategoryGetListRequest = GetListRequest<PriceCategoryGetListRequestFilter>;
export type PriceCategoryGetListResponse = GetListResponse<PriceCategory>;
export type PriceCategoryDeleteRequest = DeleteRequest;

export interface PriceCategoryGetListRequestFilter {
  /** @format int64 */
  refOrganization_Id?: number | null;
  code?: string | null;
  name?: string | null;

  /** @format int32 */
  bookingType?: number | null;
  tags?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
}

export interface PriceCategory {
  /** @format int64 */
  refOrganization_Id?: number | null;
  code?: string | null;
  name?: string | null;

  /** @format int32 */
  bookingType?: number | null;
  priceCategoryBookingType_Name?:string|null;
  tags?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;

  /** @format int64 */
  id: number;

  /** @format byte */
  system_RowVersion?: string | null;
}

export interface PriceCategoryInsertRequest {
  /** @format int64 */
  refOrganization_Id?: number | null;
  code?: string | null;
  name?: string | null;

  /** @format int32 */
  bookingType?: number | null;
  tags?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
  priceCategory_Translations: PriceCategoryTranslationInsertRequest[];
}

export interface PriceCategoryTranslationInsertRequest {
  /** @format int64 */
  refLanguage_Id?: number | null;
  translation?: string | null;
  name?: string | null;
  description?: string | null;
  tags?: string | null;
  isEnabled?: boolean | null;
}
